module.exports = __webpack_public_path__ + "static/img/play.bec4511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play.png
// module id = 57
// module chunks = 3